import { type TimeSlot } from "@clipboard-health/contract-worker-app-bff";
import { type Theme } from "@mui/material";
import { Card } from "@src/appV2/redesign/system/ui-components";

import { getGradientByTimeSlot } from "../getGradientByTimeSlot";

interface HighlightedWorkerShiftCardWrapperProps {
  children: React.ReactNode;
  shiftTimeSlot: TimeSlot;
}

export function HighlightedWorkerShiftCardWrapper(props: HighlightedWorkerShiftCardWrapperProps) {
  const { children, shiftTimeSlot } = props;

  return (
    <Card
      sx={{
        flexGrow: 1,
        background: (theme: Theme) => getGradientByTimeSlot({ timeSlot: shiftTimeSlot, theme }),
      }}
      variant="tertiary"
    >
      {children}
    </Card>
  );
}
